import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useImage } from "../../functions/helper";
import style from "./intro.module.scss";
import { CUSTOM_STYLE_PATH } from "../../app/app.sideEffects/useStyles.sideEffects.js";

const IntroImage = (props) => {
  const [showImage, setShowImage] = useState(false);

  const customImageURL = `${CUSTOM_STYLE_PATH}/img/intro/${props.imageName}`;
  const { hasLoaded, hasError } = useImage(customImageURL);

  useEffect(() => {
    if (hasError) {
      console.log(`${props.imageName} konnte nicht geladen werden`);
    }
    if (hasLoaded || hasError) {
      setShowImage(true);
    }
  }, [hasError, hasLoaded]);

  return (
    <img
      className={`mw-100 mb-4 ${!showImage ? style.hide : style.unblur}`}
      style={{ height: props.height != null ? props.height : "50%" }}
      src={hasLoaded ? customImageURL : props.fallbackImage}
    />
  );
};

IntroImage.propTypes = {
  imageName: PropTypes.string,
  fallbackImage: PropTypes.string,
};

export default IntroImage;
